module.exports = __webpack_public_path__ + "static/media/3.b57fc34c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery-db/3.jpg
// module id = 455
// module chunks = 0